export function URL(str) {
    URL.prototype.$str = str
}

URL.prototype.encode = function (param) {
    if (param == null) return ""
    var queries = []
    var t = typeof (param);
    if (t == 'string' || t == 'number' || t == 'boolean' || param instanceof Array) {
        return ""
    }
    for (var i in param) {
        let v = encodeURIComponent(param[i])
        queries.push(`${i}=${v}`)
    }
    return queries.join("&")
}
